import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function InHomeGHGEmissions() {
  return (
    <div className="art-page">
      <SEO
        title="In-Home Greenhouse Gas Emissions Testing — Rocket and Traditional Stoves, Ruhiira Uganda"
        description="CIRCODU conducted field-based emissions testing on improved and traditional cookstoves in household settings in Uganda."
        keywords="greenhouse gas emissions, cookstoves, household air pollution, clean cooking, Uganda, Ruhiira, CIRCODU, emissions testing, biomass combustion, climate impacts, Berkeley Air Monitoring Group, Columbia University Earth Institute, University of Illinois, Millennium Village, Millennium Villages Project, integrated development interventions, rural poverty, Stovetec rocket stoves, traditional three-stone stoves, in-home emissions testing, real-world validity, carbon financing, clean cooking programmes"
        url="/In-Home-Greenhouse-Gas-Emissions-Testing-Rocket-and-Traditional-Stoves-Ruhiira-Uganda"
        datePublished="2010-01-11"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              In-Home Greenhouse Gas Emissions Testing — Ruhiira, Uganda
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              January 11, 2010
            </div>
            <h1 className="art-title">
              In-Home Greenhouse Gas Emissions Testing — Rocket and Traditional
              Stoves, Ruhiira Uganda
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In 2010, CIRCODU joined a multi-institutional research team
                including <strong>Berkeley Air Monitoring Group</strong>,{" "}
                <strong>Columbia University's Earth Institute</strong>, and the{" "}
                <strong>University of Illinois</strong> to conduct field-based
                emissions testing on improved and traditional cookstoves in
                household settings in Uganda. The study took place in the{" "}
                <strong>Millennium Village of Ruhiira</strong> in Isingiro
                District, Western Uganda — a site chosen as part of the
                Millennium Villages Project, an ambitious initiative by Columbia
                University testing the impact of integrated development
                interventions on rural poverty.
              </p>
              <p>
                The study formed part of a broader research programme on
                household air pollution and the climate impacts of cooking
                technologies, contributing to the growing global evidence base
                on the health and environmental costs of traditional biomass
                combustion.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU provided critical on-the-ground support for emissions
                testing comparing{" "}
                <strong>Stovetec wood-burning rocket stoves</strong> against{" "}
                <strong>traditional three-stone open fire stoves</strong> in
                real household cooking environments. Rocket stoves are designed
                to achieve more complete combustion by directing airflow more
                efficiently to the fire, producing less smoke and consuming less
                fuel than an open fire.
              </p>
              <p>
                The field work required careful coordination with participating
                families, rigorous adherence to testing protocols, and accurate
                capture of in-home air quality and fuel consumption data under
                the variable conditions of actual household use — a
                methodological challenge that laboratory testing alone cannot
                replicate.
              </p>
              <h2 className="art-subheading">Significance</h2>
              <p>
                By measuring emissions <em>in homes</em> rather than only in
                controlled laboratory settings, this study produced findings
                with stronger real-world validity. The data contributed to the
                global evidence base on the emissions reduction potential of
                improved cookstoves and helped strengthen the scientific case
                for carbon financing of clean cooking programmes — a case that
                had profound implications for how the international community
                would invest in household energy over the following decade.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's air quality and emissions
                research, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
